(function() {
  // Yalnızca ürün sayfasında çalışsın
  if (!document.body.classList.contains('template-product')) return;

  function getCurrentVariantPriceCents() {
    // Dawn teması variant JSON içerir
    var jsonEl = document.querySelector('script[type="application/json"][data-product]');
    if (!jsonEl) return null;
    try {
      var productData = JSON.parse(jsonEl.textContent);
      if (productData && productData.selected_or_first_available_variant) {
        return productData.selected_or_first_available_variant.price; // kuruş olarak döner
      }
      if (productData && productData.variants && productData.variants.length > 0) {
        return productData.variants[0].price;
      }
    } catch (e) {
      console.warn('Variant price JSON parse error:', e);
    }
    return null;
  }

  function updateCoin() {
    var priceCents = getCurrentVariantPriceCents();
    if (!priceCents) return;
    // TL'ye çevir (100 kuruş = 1 TL). Coin formülü: TL değeri kadar coin
    var coins = Math.floor(priceCents / 100);
    var coinEl = document.querySelector('[data-cs-coin] .cs-coin-num');
    if (coinEl) {
      coinEl.textContent = coins;
    }
  }

  // Shopify Dawn varyant değişim eventi
  document.addEventListener('variant:change', function(evt) {
    updateCoin();
  });

  // İlk yüklemede çalıştır
  document.addEventListener('DOMContentLoaded', function() {
    updateCoin();
  });
})();
